var map = {
	"./DK/card-buy-page.json": 654,
	"./DR/card-buy-page.json": 655,
	"./OST2/card-buy-page.json": 656,
	"./PstViewer/card-buy-page.json": 657,
	"./SPB/card-buy-page.json": 658,
	"./Sync2/card-buy-page.json": 659,
	"./Sync2Cloud/card-buy-page.json": 660,
	"./vCard/card-buy-page.json": 661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 653;